import React from "react";
import Typography from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import flyer from "../../../assets/scholars/flyer.jpeg";

const Details = () => {
  return (
    <>
      <Grid container margin={{ xs: "8% 0%", sm: "2% 0%" }}>
        <Grid xs={12} sm={6} paddingRight={"3%"}>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            On August 11, 2024, the Oluseun Onigbinde Resource Centre hosted an
            inspiring event titled "Afternoon with the Oluseun Onigbinde
            Scholars" at the Carlton Gate Xclusive Hotel in Agodi, Ibadan. This
            event brought together the top performers from the Oluseun Onigbinde
            annual scholarship program, which supports both university
            undergraduates and postgraduates. The gathering was organized to
            recognize the achievements of the 21 scholars and other scholarship
            beneficiaries, celebrating their academic excellence and commitment
            to personal growth.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            The program provided a platform for these outstanding students to
            gain valuable career insights and guidance from a distinguished
            panel of speakers. Oluseun Onigbinde, the Global Director of BudgIT
            Foundation, led the discussions, sharing his experiences and
            offering advice on how to navigate the challenges of academic and
            professional life. He was joined by other prominent industry
            leaders, including Steve Okeleji, MD/CEO of Aquatic Hub Afrique;
            Kola Kelani, CFO of Bono Energy Ltd; Edem Dorothy Ossai, Executive
            Director of MAYEIN; Adejare Kikelomo, Regulatory Officer at NAFDAC;
            and Tope Daramola, General Manager of HR & Corporate at Energia Ltd.
            Each speaker contributed unique perspectives on career development,
            emphasizing the importance of hard work, innovation, and integrity.
          </Typography>
          <Typography
            variant={"body1"}
            color={"#000"}
            paddingBottom={"4%"}
            lineHeight={1.5}
          >
            The event not only celebrated the scholars' academic success but
            also equipped them with the tools and knowledge needed to excel in
            their future careers. Through this engagement, the Oluseun Onigbinde
            Resource Centre reinforced its commitment to nurturing the next
            generation of leaders and professionals. The scholars left the event
            inspired and motivated, with a renewed sense of purpose and a
            clearer vision of their paths ahead.
          </Typography>
        </Grid>
        <Grid xs={12} sm={6} display={{ xs: "none", sm: "block" }}>
          <Box
            component="img"
            height={{ xs: "95vh", sm: "650px" }}
            sx={{
              objectFit: "cover",
              width: "100%",
            }}
            src={flyer}
            alt={"image"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Details;
